<script>
export default {
  name: 'PageNotFound',
  created: function () {
    window.location.href = 'https://followapp.y2services.com/introduce.html'
  }
}
</script>
